
import { Loader } from "@googlemaps/js-api-loader"
import { getAppConfig } from "@/plugins/env"
import { getImgUrl } from "@/plugins/website"

export default {
  props: {
    activeItem: {
      type: Object,
      default: () => {}
    },
    storeList: {
      type: Array,
      default: () => []
    },
    currentPosition: {
      type: Object,
      default: () => {}
    },
    firstStore: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      map: null,
      google: null,
      currentPositionMarker: null,
      markers: []
    }
  },
  computed: {
    mapAndStoreList() {
      return {
        map: this.map,
        storeList: this.storeList
      }
    },
    mapAndCurrentPositionAndFirstStore() {
      return {
        map: this.map,
        currentPosition: this.currentPosition,
        firstStore: this.firstStore
      }
    }
  },
  watch: {
    mapAndStoreList() {
      if (this.map && this.storeList && this.storeList.length) {
        console.log("mapAndStoreList", this.mapAndStoreList)
        this.handleMarker()
      }
    },
    mapAndCurrentPositionAndFirstStore() {
      if (!this.map) return

      console.log("mapAndCurrentPositionAndFirstStore", this.mapAndCurrentPositionAndFirstStore)
      // 有自动定位，地图中心展示当前位置定位
      const { latitude, longitude } = this.currentPosition
      if (latitude && latitude) {
        if (this.currentPositionMarker) {
          this.currentPositionMarker.setMap(null)
          this.currentPositionMarker = null
        }

        this.currentPositionMarker = new this.google.maps.Marker({
          position: {
            lat: latitude,
            lng: longitude
          },
          map: this.map,
          icon: getImgUrl("location.png")
        })
        this.setMapCenter(latitude, longitude)

        return
      }

      // 没有选择门店时，展示第一条门店位置
      if (!this.activeItem || !("erpStoreId" in this.activeItem)) {
        this.setMapCenter(this.firstStore.lat, this.firstStore.lng)
      }
    },
    "activeItem.erpStoreId": {
      handler() {
        const oldActiveMarkers = this.markers.filter(marker => marker.icon?.includes("711StoreMarkerSelect"))
        oldActiveMarkers.forEach(marker => {
          marker.setIcon(getImgUrl("711StoreMarker.svg"))
        })

        const activeMarker = this.markers.find(marker => this.isActive(marker))
        if (activeMarker && activeMarker.setIcon) {
          activeMarker.setIcon(getImgUrl("711StoreMarkerSelect.svg"))
        }
        this.setMapCenter(this.activeItem.lat, this.activeItem.lng)
      }
    }
  },
  mounted() {
    this.loadMap()
  },
  methods: {
    loadMap() {
      const { googleMapApiKey } = getAppConfig()
      const loader = new Loader({
        apiKey: googleMapApiKey,
        version: "weekly",
        libraries: ["places"]
      })
      loader.load().then(google => {
        this.google = google
        this.initMap()
      })
    },
    initMap() {
      const mapOptions = {
        zoomControl: true,
        mapTypeControl: false,
        zoomControlOptions: {
          position: this.google.maps.ControlPosition.TOP_RIGHT
        },
        fullscreenControl: false
      }
      this.map = new this.google.maps.Map(this.$refs.map, {
        center: {
          lat: this.activeItem.lat || this.firstStore.lat || 22.320047,
          lng: this.activeItem.lng || this.firstStore.lng || 114.173355
        },
        zoom: 15,
        ...mapOptions
      })
    },
    setMapOnAll(map) {
      this.markers.forEach(marker => {
        marker.setMap(map)
      })
    },
    handleMarker() {
      this.setMapOnAll(null)
      this.markers = []
      const locations = this.storeList.map(item => ({
        lat: item.lat,
        lng: item.lng,
        id: item.id
      }))
      locations.forEach(location => {
        this.addMarker(location)
      })
    },
    addMarker(location) {
      const marker = new this.google.maps.Marker({
        id: location.id,
        position: location,
        map: this.map,
        icon: getImgUrl(this.isActive(location) ? "711StoreMarkerSelect.svg" : "711StoreMarker.svg")
      })
      this.markers.push(marker)

      marker.addListener("click", event => {
        console.log("location===>", location)
        this.$emit("change", location.id)
      })
    },
    setMapCenter(lat, lng) {
      if (this.map) {
        this.map.setCenter({
          lat,
          lng
        })
      }
    },
    isActive(item) {
      return this.activeItem.id && item.id && this.activeItem.id === item.id
    }
  }
}
